/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import gql from 'graphql-tag';
export const RENEW_MARRIAGE_EXEMPTION = gql`
  mutation RenewMarriageExemptionCertificate($credentialNo: String!) {
    renewMarriageExemptionCertificate(credentialNo: $credentialNo) {
      applicationNo
      type
      applicant
      status
      appliedBy
      comment
      applicantInfo {
        email
        name
        firstName
        middleName
        isLastNameExist
        lastName
        fullName
        nationality

        address {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
        occupation
        alias
        gender
        placeOfBirth
        dateOfBirth
        childrenOrDependent
        maritalStatus
        trn
        passportNumber
        passportIssuanceDate
        passportExpiry
        passportType
        workExperience {
          nameOfOrganization
          from
          to
          jobDuty
          refLetter
        }
        skills
        image
        bannerImg
        bio
        vuid
        userId
        emailVerified
        phoneVerified
        accountStatus
        org {
          orgId
          name
          tradingName
          description
          email
          registrationNo
          trn
          incorporationDate
          type
          dateOfRegistration
          fax
          isOperatingAddressSame
          natureOfBusiness
          website
          primaryContactNo
          landlineContactNo
          logo
          socialLinks
          country
          businessRegistrationExpiryDate
          status
          isSubsidiary
          contactPerson
          isDirectorExist
          isSubsidiaryExist
          isBranchExist
          reason
          workPermitIsInRelationTo
          credentialNo
          wpExpiry
          tccNumber
          tccExpiryDate
        }
        primaryContactNo
        orgRoles {
          orgId {
            orgId
            name
          }
          role {
            name
            uuid
          }
        }
        createdAt
        isDependentExist
        isNameChange
        isMailingAddressSame
        isFirstNameChange
        isMiddleNameChange
        isLastNameChange
        isOccupationChange
        isNationalityChange
        isPassportExpired
        maidenName
        previouslyMarried
        divorceOrWidowed
        refusedVisaOrDenied
        refusedVisaOrDeniedReason
        refusedJamaicanVisa
        refusedJamaicanVisaReason
        criminalActivity
        criminalActivityReason
        employed
        salary
        financiallyCapable
        typeOfIdentification
        NIS
        nameOfEmployer
        addressOfEmployer {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
        otherIncomeSource
        notfinanciallyCapableReason
        refusionDetail {
          country
          reason
        }
        permissionPeriod {
          from
          to
        }
        lastEmployer {
          orgId
          name
          tradingName
          description
          email
          registrationNo
          trn
          incorporationDate
          type
          dateOfRegistration
          fax
          isOperatingAddressSame
          natureOfBusiness
          website
          primaryContactNo
          landlineContactNo
          logo
          socialLinks
          country
          businessRegistrationExpiryDate
          status
          isSubsidiary
          contactPerson
          isDirectorExist
          isSubsidiaryExist
          isBranchExist
          reason
          workPermitIsInRelationTo
          credentialNo
          wpExpiry
          tccNumber
          tccExpiryDate
        }
        spouseName
        spouseNationality
        spouseLastEmployer {
          orgId
          name
          tradingName
          description
          email
          registrationNo
          trn
          incorporationDate
          type
          dateOfRegistration
          fax
          isOperatingAddressSame
          natureOfBusiness
          website
          primaryContactNo
          landlineContactNo
          logo
          socialLinks
          country
          businessRegistrationExpiryDate
          status
          isSubsidiary
          contactPerson
          isDirectorExist
          isSubsidiaryExist
          isBranchExist
          reason
          workPermitIsInRelationTo
          credentialNo
          wpExpiry
          tccNumber
          tccExpiryDate
        }
        declaration {
          value
          selected
        }
        criminalOffence
        countryConvicted
        dateOfConviction
        natureOfOffence
        workedInJamaica
        destinationCarribbeanState
        purposeOfRelocation
        natureOfBusiness
        natureOfProfessionalActivity
        nameChangeDocType
        dateOfEntry
        portOfEntry
        employmentStatus
        highestQualification
        employmentAddress {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
      }
      certificateInfo {
        issuingAutority
        dateOfApplication
        issuanceDate
      }
      employerInfo {
        orgId
        name
        tradingName
        description
        email
        registrationNo
        trn
        incorporationDate
        type
        dateOfRegistration
        fax
        isOperatingAddressSame
        operatingAddress {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
        natureOfBusiness
        website
        primaryContactNo
        landlineContactNo
        logo
        socialLinks
        country
        businessRegistrationExpiryDate
        status
        isSubsidiary
        contactPerson
        documents {
          name
          type
          src
          fileType
          expiry
        }
        directors {
          email
          name
          firstName
          middleName
          isLastNameExist
          lastName
          fullName
          nationality
          occupation
          alias
          gender
          placeOfBirth
          dateOfBirth
          childrenOrDependent
          maritalStatus
          trn
          passportNumber
          passportIssuanceDate
          passportExpiry
          passportType
          skills
          image
          bannerImg
          bio
          vuid
          userId
          emailVerified
          phoneVerified
          accountStatus
          primaryContactNo

          createdAt
          isDependentExist
          isNameChange
          isMailingAddressSame
          isFirstNameChange
          isMiddleNameChange
          isLastNameChange
          isOccupationChange
          isNationalityChange
          isPassportExpired
          maidenName
          previouslyMarried
          divorceOrWidowed
          refusedVisaOrDenied
          refusedVisaOrDeniedReason
          refusedJamaicanVisa
          refusedJamaicanVisaReason
          criminalActivity
          criminalActivityReason
          employed
          salary
          financiallyCapable
          typeOfIdentification
          NIS
          nameOfEmployer
          otherIncomeSource
          notfinanciallyCapableReason
          spouseName
          spouseNationality
          criminalOffence
          countryConvicted
          dateOfConviction
          natureOfOffence
          workedInJamaica
          destinationCarribbeanState
          purposeOfRelocation
          natureOfBusiness
          natureOfProfessionalActivity
          nameChangeDocType
          dateOfEntry
          portOfEntry
          employmentStatus
          highestQualification
        }
        branches {
          orgId
          name
          tradingName
          description
          email
          registrationNo
          trn
          incorporationDate
          type
          dateOfRegistration
          fax
          isOperatingAddressSame
          natureOfBusiness
          website
          primaryContactNo
          landlineContactNo
          logo
          socialLinks
          country
          businessRegistrationExpiryDate
          status
          isSubsidiary
          contactPerson
          isDirectorExist
          isSubsidiaryExist
          isBranchExist
          reason
          workPermitIsInRelationTo
          credentialNo
          wpExpiry
          tccNumber
          tccExpiryDate
        }
        subsidiaries {
          orgId
          name
          tradingName
          description
          email
          registrationNo
          trn
          incorporationDate
          type
          dateOfRegistration
          fax
          isOperatingAddressSame
          natureOfBusiness
          website
          primaryContactNo
          landlineContactNo
          logo
          socialLinks
          country
          businessRegistrationExpiryDate
          status
          isSubsidiary
          contactPerson
          isDirectorExist
          isSubsidiaryExist
          isBranchExist
          reason
          workPermitIsInRelationTo
          credentialNo
          wpExpiry
          tccNumber
          tccExpiryDate
        }
        isDirectorExist
        isSubsidiaryExist
        isBranchExist
        reason
        workPermitIsInRelationTo
        saffCompsition {
          citizenship
          professional
          clerksOrServiceWorker
          skilledWorkers
          plantAndMachineOperators
          elementaryOccupations
          total
        }
        credentialNo
        wpExpiry
        tccNumber
        tccExpiryDate
      }

      jamaicanInfo {
        email
        firstName
        middleName
        lastName
        nationality
        maidenName
        placeOfBirth
        gender
        dateOfBirth
        typeOfIdentification
        NIS
        trn
        occupation
        previouslyMarried
        divorceOrWidowed
        employed
        salary
        primaryContactNo
        financiallyCapable
        nameOfEmployer
        otherIncomeSource
        notfinanciallyCapableReason
        jamaicanEmployedState
        jamaincaSpouseLiving
        birthCertificateNo
        NaturalizationCertificateNo
        citizenshipProof
      }
      marriageInfo {
        marriageCertificateNo
        nameOfOfficer
        groomName
        brideName
        placeOfMarriage
        dateOfMarriage

        addressOfCouple {
          addressLine1
          addressLine2
          addressLine3
          city
          state
          parish
          zipcode
          country
        }
      }
      jobInfo {
        JobId
        JobTitle
        jobDuties
        description
        registeredLMIS
        salaryOffered
        allowances {
          house
          car
          entertainment
          other
        }
        necessaryQualification
        currency
        stepsForJaimacan {
          internalRecruitment
          byAdvertisement

          didJamaicanApply
          appliedCandidates
          reasonNoneHired
          noStepTaken
        }
        workingHours
        benefitsReceived
      }
      documents {
        name
        type
        src
        fileType
        expiry
      }
      createdAt
      updatedAt
      appliedOn
      completedOn
      appealInfo {
        applicationNo
        comment
        createdAt
        updatedAt
      }
      dependentInfo {
        dependentType
        name
        relationship
        passportNumber
        age
        gender
        nationality
      }
    }
  }
`;
